module.exports = __webpack_public_path__ + "static/media/bg.709ec058.png";